<template>
    <img src="/images/promo/hero-section/bell.png"
     alt="Bell" />
</template>

<script>
export default {};
</script>
